<template>
  <div class="__nav">
    <button class="btn_filtres" v-if="showfiltres == false" @click="statusFiltres(true)">{{ $t("message.affiner_recherche") }}</button>
    <button class="btn_filtres" v-else @click="statusFiltres(false)">{{ $t("message.fermer_filtres") }}</button>
    <span class="resultats" v-if="current > 0">
      {{ current }} {{ $t("message.textsur") }} {{ this.pagination.total }} 
      <span v-if="current < 2">{{ $t("message.resultat") }}</span>
      <span v-else>{{ $t("message.resultats") }}</span>
    </span>
    
    <a :href="this.api.wishlist_link" class="wishlistCounter" v-if="countWishlist">{{ $t("message.selection") }} ({{ this.wishlist.length }})</a>
    <button class="btn_map" v-if="this.showmap == true" @click="statusMap(false)">{{ $t("message.masquer_carte") }}</button>
    <button class="btn_map" v-else @click="statusMap(true)">{{ $t("message.afficher_carte") }}</button>
  </div>
</template>
<script>
export default {
  name: 'NavOffres',  
  data: function() {
    return { 
      current : null,
      countWishlist : this.wishlist
    }
  },
  props: ['pagination', 'api', 'geoloc', 'wishlist', 'showmap', 'showfiltres'],
  components: {
    
  },
  methods : {
    getResults(pagination, api) {
      if(pagination.current * api.per_page >= pagination.total) {
        return pagination.total;
      }
      else {
        return (pagination.current * api.per_page);
      }
    }, 
    statusMap(status) {
      this.$emit('showMap', status);
    },
    statusFiltres(status) {
      this.$emit('showFiltres', status);
    }
  },
  mounted() {
    this.current = this.getResults(this.pagination, this.api);
  },
  watch: {
    pagination: {
      handler() {
        this.current = this.getResults(this.pagination, this.api);
      },
      deep:true
    }
  }
}
</script>